import { shopifyAPI } from "../api";

export class ProductItem extends HTMLElement {
  constructor() {
    super();
    // Parse JSON once
    this._variants = this.dataset.variants ? JSON.parse(this.dataset.variants) : null;
    this._collection = this.dataset.collection ? JSON.parse(this.dataset.collection) : null;
    // Store DOM references
    this._elements = {
      variantInput: this.querySelector('input[name="variant-id"]'),
      atcButtons: Array.from(this.querySelectorAll(".js-atc-button")),
    };
    // Bind once
    this._boundAddToCard = this._addToCard.bind(this);
  }

  connectedCallback() {
    // Use event delegation instead of multiple listeners
    this._elements.atcButtons.forEach((button) =>
      button.addEventListener("click", this._boundAddToCard)
    );
  }

  disconnectedCallback() {
    // Cleanup
    this._elements.atcButtons.forEach((button) =>
      button.removeEventListener("click", this._boundAddToCard)
    );
  }

  async _addToCard(e) {
    e.preventDefault();

    try {
      document.dispatchEvent(new CustomEvent("theme:loading:start"));

      const properties = {
        Auteur: this.author,
      };

      if (this._collection?.title) {
        properties._collectionTitle = this._collection.title;
      }

      if (this._collection?.id) {
        properties._collectionId = this._collection.id;
      }

      const data = await shopifyAPI.cart.addItem(this.variantId, 1, null, properties);

      if (data) {
        window.dataLayer.push({
          'cloud_retail': ''
        })
        window.dataLayer.push(this.atcEventData);
        document.documentElement.dispatchEvent(
          new CustomEvent("product:added", {
            detail: {
              button: this,
              variant: this.variantId,
              quantity: 1,
              properties: { Auteur: this.author },
            },
          })
        );
      }
    } catch (error) {
      console.error("Add to cart failed:", error);
    } finally {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    }
  }

  get variantId() {
    return this._elements.variantInput?.value;
  }

  get variants() {
    return this._variants; // Return cached value
  }

  set variantId(value) {
    this._variantInput.value = value;
  }

  get author() {
    return this.dataset.author;
  }

  get isbn() {
    return this.dataset.isbn;
  }

  get atcEventData() {
    const eventData = this.dataset.atcEventData ? JSON.parse(this.dataset.atcEventData) : { cloud_retail: {} };
    eventData.cloud_retail.attributionToken = sessionStorage.getItem('attributionToken') ? sessionStorage.getItem('attributionToken') : null;
    eventData.cloud_retail.visitorId = localStorage.getItem("visitorId");
    eventData.cloud_retail.cartId = window.cartToken;
    eventData.cloud_retail.userInfo = { userId: window.userId };
    return eventData;
  }
}

customElements.define("product-item", ProductItem);
